var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-tags"},_vm._l((_vm.Items),function(item,index){return _c('ui-tags-item',{key:index,attrs:{"item":item,"title":item.Value.ToString(),"edit":_vm.edit},on:{"close":function($event){return _vm.close(item)}}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5eea56","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-tags/src/ui-tags.vue
// module id = 686
// module chunks = 0